/**** AUTH ****/
export const AUTH_JWT_TOKEN: string = "AUTH_JWT_TOKEN";
export const AUTH_JWT_TOKEN_EXPIRATION: string = "AUTH_JWT_TOKEN_EXPIRATION";
export const AUTH_REFRESH_TOKEN: string = "AUTH_REFRESH_TOKEN";
export const AUTH_REFRESH_TOKEN_EXPIRATION: string = "AUTH_REFRESH_TOKEN_EXPIRATION";

export const BULK_SELECT_VIEW_MODE = "BULK_SELECT_VIEW_MODE";
